<div class="summary" *ngIf="data.length > 0">
	<div class="table-container">
		<table>
			<thead>
				<tr>
					<H2>Animales faltantes</H2>
				</tr>
			</thead>
			<tbody>
				<tr *ngFor="let animal of data">
					<td>{{ animal }}</td>
				</tr>
			</tbody>
		</table>
	</div>
</div>
<div class="summary" *ngIf="data.length == 0">
	<h2>No hay animales faltantes</h2>

	<button class="app-btn tertiary excel-btn" (click)="onClose()">Ok</button>
</div>
